/**
 * Fallback-rule shapes for the Send Test form. `FallbackRuleForm` is the UI edit
 * shape (minutes as `after`); `FallbackRule` is the API shape (`afterMinutes`).
 */
import type { ChannelType } from '../notification';

export interface FallbackRuleForm {
  from: ChannelType;
  to: ChannelType;
  after: number;
}

export interface FallbackRule {
  from: ChannelType;
  to: ChannelType;
  afterMinutes: number;
}

export const toApiFallback = (r: FallbackRuleForm): FallbackRule => ({
  from: r.from,
  to: r.to,
  afterMinutes: r.after,
});
